import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private titleSubj = new BehaviorSubject<string>('');
  private subtitleSubj = new BehaviorSubject<string>('');

  constructor(private titleService: Title) {}

  public get title$(): Observable<string> {
    return this.titleSubj.asObservable();
  }

  public get subtitle$(): Observable<string> {
    return this.subtitleSubj.asObservable();
  }

  public setTitle(title: string, subtitle?: string): void {
    this.titleSubj.next(title);
    this.titleService.setTitle(title + ' - Closecare');
    this.subtitleSubj.next(subtitle || '');
  }

  public setSubtitle(subtitle: string): void {
    this.subtitleSubj.next(subtitle);
  }

  public getTitle(): string {
    return this.titleSubj.getValue();
  }

  public getSubtitle(): string {
    return this.subtitleSubj.getValue();
  }

  public getCompleteTitle(): string {
    return this.titleService.getTitle();
  }

  getTitleService(): Title {
    return this.titleService;
  }
}
